export const CourseCatalog = {
  ballet: {
    name: '芭蕾课程',
    msg: '<p style="text-align: center;line-height: 12px;margin: .5rem 0;">系统地学习芭蕾动作</p><p style="text-align: center;line-height: 12px;">循序渐进地完成一节完整的芭蕾基础课</p>',
    data: [
      {
        lv: '入门',
        id: 'intro',
        class: 'color-primary',
        courseList: [
          {
            id: 'ballet-intro',
            title: '芭蕾入门',
            msg: '学习芭蕾基本姿态与用力方式',
            basics: '零基础'
          },
        ]
      },
      {
        lv: '初级',
        id: 'primer',
        class: 'color-primary',
        courseList: [
          {
            id: 'primer1',
            title: '初级一阶',
            msg: '学习1/3的基础扶把动作',
            basics: '2个月'
          },
          {
            id: 'primer2',
            title: '初级二阶',
            msg: '学习2/3的基础扶把动作',
            basics: '4个月'
          },
          {
            id: 'primer3',
            title: '初级三阶',
            msg: '学习全部基础扶把动作',
            basics: '6个月'
          },
          {
            id: 'primer4',
            title: '初级常规',
            msg: '完成芭蕾元素的不同组合方式',
            basics: '1年'
          },
        ]
      },
      {
        lv: '中级',
        id: 'middle',
        class: 'color-primary',
        courseList: [
          {
            id: 'middle1',
            title: '中级预备',
            msg: '学习基础旋转与中跳等难度动作',
            basics: '2年'
          },
          {
            id: 'middle2',
            title: '中级芭蕾',
            msg: '完成复杂的组合,增强舞姿意识',
            basics: '3年'
          },
          {
            id: 'middle3',
            title: '中级提升',
            msg: '完成高难度内容,自主处理动作',
            basics: '5年'
          }
        ]
      },
    ]
  },
  auxiliary: {
    name: '辅助课程',
    msg: '',
    data: [
      {
        lv: '辅助',
        id: 'fuzhu1',
        class: 'color-primary',
        courseList: [
          {
            id: 'fuzhu1-intro',
            title: '芭蕾入门',
            msg: '学习芭蕾基本姿态与用力方式',
            basics: '零基础'
          },
        ]
      },
      {
        lv: '辅助',
        id: 'fuzhu2',
        class: 'color-primary',
        courseList: [
          {
            id: 'fuzhu2s',
            title: '中级预备',
            msg: '学习基础旋转与中跳等难度动作',
            basics: '2年'
          },
          {
            id: 'fuzhu2ss',
            title: '中级芭蕾',
            msg: '完成复杂的组合,增强舞姿意识',
            basics: '3年'
          },
          {
            id: 'fuzhu2sss',
            title: '中级提升',
            msg: '完成高难度内容,自主处理动作',
            basics: '5年'
          }
        ]
      },
    ]
  }
};
